import { SET_FILTERS, SET_TAB } from "actions/foldersOverview";

export function setFilters(startDate, endDate, showDone, page, search, size, centers, box) {
	return {
		type: SET_FILTERS,
		payload: {
			data: {
				startDate: startDate,
				endDate: endDate,
				showDone: showDone,
				page: page,
				search: search,
				sizePage: size,
				centers: centers,
				box: box,
			},
		},
	};
}

export function setTab(tab) {
	return {
		type: SET_TAB,
		payload: tab,
	};
}
